import _pick from 'lodash/pick';
import MappingProps from 'types/Mapping';
import {
  ORG_MAPPING_TYPE_KEY,
  ORG_TEAM_LEADER_MAPPING_REF_KEY,
  ORG_TEAM_LEADER_MAPPING_MATCH_KEY,
  HIERARCHY_MAPPING_KEY,
} from 'pages/Directory/consts';

const VALID_PROPS = [
  'source',
  'destination',
  'isRequired',
  'isUnique',
  'type',
  '_referenceId',
  'id',
  'sourceId',
  'collectionItemType',
  'collectionItemCustomType',
];

function transformMappingsForValidation(mappings: MappingProps[]) {
  const filteredMappings = mappings.reduce((acc, mapping) => {
    const { source, destination, type } = mapping;

    if (!source || !destination) {
      return acc;
    }

    const updatedType = type === ORG_MAPPING_TYPE_KEY ? 'data' : type;

    acc.push(_pick({ ...mapping, type: updatedType }, VALID_PROPS));

    return acc;
  }, [] as any[]);

  if (
    !filteredMappings.some(m => m.type === HIERARCHY_MAPPING_KEY) &&
    filteredMappings.some(m =>
      [ORG_TEAM_LEADER_MAPPING_MATCH_KEY, ORG_TEAM_LEADER_MAPPING_REF_KEY].includes(m.destination),
    )
  ) {
    filteredMappings.push({
      source: ORG_TEAM_LEADER_MAPPING_REF_KEY,
      destination: ORG_TEAM_LEADER_MAPPING_MATCH_KEY,
      isRequired: false,
      isUnique: false,
      type: HIERARCHY_MAPPING_KEY,
    });
  }

  return filteredMappings;
}

export default transformMappingsForValidation;
